import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Text } from '../../../../../packages/ui/atoms/typography';
import { Input, inputType } from '../../../../../packages/ui/atoms/input';
import { ReportCollapseItems } from '../report-items-collapse';
import { useStyles } from './StepOne.styles';

const StepOne = ({
  selectedItems,
  setSelectedItems,
  options,
  searchLabel,
  singleSelection = false,
  excludeLabels = [],
}) => {
  const classes = useStyles();
  const [searchKey, setSearchKey] = useState('');
  const [itemsFiltered, setItemsFiltered] = useState([]);
  const total = options.length * 4;

  // Handle single selection - when an item is selected, replace any existing selection
  const handleSingleSelection = newList => {
    // If the new list has more items than current selection, it means a new item was added
    if (newList.length > selectedItems.length) {
      // Keep only the newly added item (last item in the list)
      const newItem = newList.find(item => !selectedItems.includes(item));
      setSelectedItems(newItem ? [newItem] : []);
    } else {
      // Item was deselected, use the new list as is
      setSelectedItems(newList);
    }
  };

  useEffect(() => {
    const excludeLower = excludeLabels.map(l => l.toLowerCase());
    const newItems = options.reduce((arr, currentItem) => {
      const items = currentItem.items.filter(
        i =>
          i.label.toLowerCase().includes(searchKey.toLowerCase()) &&
          !excludeLower.includes(i.label.toLowerCase()),
      );
      if (items.length > 0) {
        return [...arr, { ...currentItem, items }];
      }
      return arr;
    }, []);
    setItemsFiltered(newItems);
  }, [searchKey, options, excludeLabels]);

  return (
    <Box className={classes.container}>
      <Box className={classes.searchBox}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Text className={classes.label}>{searchLabel}</Text>
          <Text className={classes.count}>
            {singleSelection
              ? selectedItems.length > 0
                ? '1 selected'
                : 'None selected'
              : `${selectedItems.length} of ${total} selected`}
          </Text>
        </Box>
        <Input
          className={classes.searchInput}
          variant={inputType.SEARCH}
          placeholder="Search"
          value={searchKey}
          onChange={setSearchKey}
        />
      </Box>
      <Box className={classes.sections}>
        {itemsFiltered.length > 0 ? (
          itemsFiltered
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((section, idx) => (
              <ReportCollapseItems
                items={section.items}
                selectedItems={selectedItems}
                open={idx === 0}
                onChange={singleSelection ? handleSingleSelection : setSelectedItems}
                key={section.label}
                label={section.label}
              />
            ))
        ) : (
          <Box display="flex" justifyContent="center">
            <Text className={classes.noData}>No data available</Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default StepOne;
